import { defineStore } from 'pinia'
import { APP_CODE } from '@/assets/js/config.js'

export const useConfigStore = defineStore('configStore', {
  state: () => ({
    app_code: '', // Initialize app_code as null initially
		sectionLoadings:[]
  }),
  actions: {
    async fetchAndSetAppCode() {
      const { hostname } = new URL(window.location.href);
      var subHostname = hostname.split('.')[0]

      const isAppCodeExistLocalStorage = localStorage.getItem('app_code');
      if (!isAppCodeExistLocalStorage) {
        
				//GET FROM ENV
				if (!_gHlp.isEmpty(APP_CODE)) {
					localStorage.setItem('app_code', APP_CODE);
					this.app_code = APP_CODE; // Update the store state
				//GET FROM SUB DOMAIN	
				} else {

					if(subHostname === 'sas-v2' || subHostname === 'sas-uat-v2'){
						this.app_code = 'sas_v2';
					}
					if(subHostname === 'vps-v2' || subHostname === 'vps-uat-v2'){
						this.app_code = 'vps-v2';
					}
					
          localStorage.setItem('app_code', this.app_code);
        } 
      } else {
        this.app_code = isAppCodeExistLocalStorage; // Set app_code from local storage
      }
    },
		setLoading(item){
			this.sectionLoadings.push(item)
		},
		removeLoading(value){
			const index = this.sectionLoadings.indexOf(value);
			// Check if the value exists in the array
			if (index !== -1) {
					// Remove the item at the found index
					this.sectionLoadings.splice(index, 1);
			}
		},
  }
})
